import React from 'react';
import { Button, DialogContent, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, makeStyles} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { useBuilderPreview } from '../../../utilities/useBuilderPreview';

const useStyles = makeStyles(() => ({
    submitButton: {
        width: 250,
        color: "#FFF",
        backgroundColor: "rgb(50, 153, 57)",
        "&:hover": {
            backgroundColor: "rgb(50, 153, 57, .8)",
        },
        "&:disabled": {
            backgroundColor: "rgb(50, 153, 57, .5)",
        },
    },
}));

const bulletPoints = [
    <>Intelligent suggestions engine for <strong>fresh ideas</strong></>,
    <>Real-time sermon analyzer for <strong>better sermons</strong></>,
    <>Integrated sermon slide builder for <strong>clearer preaching</strong></>,
    <>Organize your sermon library and <strong>preach with confidence</strong></>,
]

interface Props {
    onSelectMakerCheckout: () => void;
    onSelectedBundleCheckOut: () => void;
}

export function SignUpOfferDialog(props:Props) {
    const previewContext = useBuilderPreview();
    const { user } = previewContext;
    const classes = useStyles();

    if(user === null){
        return null;
    }

    return (
        <>
            <Typography variant="h3" style={{color: "rgb(50, 153, 57, .8)", padding: "24px 24px 5px 24px" }} >
                { user.proSubscription ? 'Your Pro Discount...' : 'Preach better sermons'}
            </Typography>
            <DialogContent>
                <Grid container justifyContent="center" alignItems="center" direction="column">
                    { user.proSubscription
                    ?
                        <Typography>
                            Sermon Maker helps you organize & preach better. Active PRO members can <strong>save over $100</strong> on Sermon Maker for 1 year.
                        </Typography>
                    :
                        <Typography>
                            Sermon Maker helps you preach confidently. Bundle with SermonCentral PRO and <strong>save over $100</strong> today.
                        </Typography>
                    }
                    <List>
                        { bulletPoints.map( (li, index) => {
                            return (
                            <ListItem style={{ padding: '0px 5px' }} key={index}>
                            <ListItemIcon style={{ marginRight: 0}}>
                                <CheckIcon style={{ color: "rgb(50, 153, 57, .8)", fontSize: 'small'}} />
                            </ListItemIcon>
                            <ListItemText>{li}</ListItemText>
                            </ListItem>
                            )}
                        )}
                    </List>
                    { user.proSubscription
                        ?
                        <Grid container direction="column" alignItems="center" justifyContent="center" style={{paddingTop: 5, paddingBottom: 5}}>
                            <Grid item>
                                <Button 
                                    onClick={props.onSelectMakerCheckout}
                                    variant="contained" 
                                    size="medium" 
                                    fullWidth
                                    className={classes.submitButton}
                                    >Get Started Free</Button>
                            </Grid>
                            <Grid item>
                                <Typography align="center" variant="body2" style={{ opacity: .88, marginTop: 5 }}>{user.userCanHaveTrial && "14 days free, then "}<s>$19.00</s> $9.99/mo cancel anytime</Typography>
                            </Grid>
                        </Grid>
                        :
                        <Grid container direction="row" justifyContent="space-around" style={{paddingTop: 5, paddingBottom: 5}}>
                            <Grid item>
                                <Button 
                                    onClick={props.onSelectedBundleCheckOut}
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    className={classes.submitButton}
                                    >PRO + Sermon Maker</Button>
                                <Typography align="center" variant="body2" style={{ opacity: .88, marginTop: 5 }}>Save $100 today</Typography>
                            </Grid>
                            <Grid item>
                                <Button 
                                    onClick={props.onSelectMakerCheckout}
                                    variant="contained" 
                                    fullWidth
                                    size="large"
                                    className={classes.submitButton}
                                    >Sermon Maker</Button>
                                <Typography align="center" variant="body2" style={{ opacity: .88, marginTop: 5 }}>14 days free</Typography>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </>
    );
}